import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS, NAV_LINKS, LOGO } from "../../lib/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 bg-navy/95 backdrop-blur-md border-b border-deep">
      <div className="container-pr7 flex items-center justify-between h-16 lg:h-[72px]">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group" onClick={() => setOpen(false)}>
          <img src={LOGO} alt="PR7 MOT Centre" className="h-[52px] lg:h-[60px] w-auto rounded-sm drop-shadow-[0_0_12px_rgba(61,142,245,0.35)]" />
          <span className="leading-tight">
            <span className="block font-heading font-extrabold text-white tracking-wide text-base sm:text-lg">MOT CENTRE</span>
            <span className="block text-[11px] sm:text-xs text-sky/80 font-medium tracking-wider">{BUSINESS.tagline}</span>
          </span>
        </Link>

        <nav data-testid="desktop-nav" className="hidden lg:flex items-center gap-0.5">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-2.5 py-2 text-xs font-semibold tracking-wide rounded whitespace-nowrap transition-colors ${
                  isActive ? "text-white bg-deep" : "text-pale/70 hover:text-white hover:bg-deep/60"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={BUSINESS.phoneHref}
            data-testid="header-phone"
            className="hidden 2xl:inline-flex items-center gap-2 text-pale/80 hover:text-white text-sm font-semibold whitespace-nowrap transition-colors"
          >
            <Phone size={15} className="text-sky" /> {BUSINESS.phone}
          </a>
          <Link
            to="/booking?service=MOT"
            data-testid="nav-book-mot-btn"
            className="hidden sm:inline-flex bg-brand hover:bg-sky text-white font-heading font-bold text-sm tracking-wide px-4 py-2.5 rounded whitespace-nowrap transition-colors"
          >
            BOOK AN MOT
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-2 -mr-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="mobile-nav" className="lg:hidden bg-navy border-t border-deep">
          <div className="container-pr7 py-3 flex flex-col">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3.5 px-2 text-base font-semibold border-b border-deep/50 ${isActive || (l.to !== "/" && location.pathname.startsWith(l.to)) ? "text-sky" : "text-pale/85"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/booking?service=MOT"
              data-testid="mobile-nav-book-mot"
              onClick={() => setOpen(false)}
              className="mt-4 mb-2 bg-brand text-white text-center font-heading font-bold tracking-wide py-3.5 rounded"
            >
              BOOK AN MOT
            </Link>
            <a
              href={BUSINESS.phoneHref}
              data-testid="mobile-nav-call"
              className="mb-3 border border-sky/40 text-white text-center font-heading font-bold tracking-wide py-3.5 rounded"
            >
              CALL {BUSINESS.phone}
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
